// extracted by mini-css-extract-plugin
export default {"tab":"badge_tab__zsURZ","badgeContainer":"badge_badgeContainer__ScoDH","badge":"badge_badge__i2C7C","active":"badge_active__GucHM"};